export type CheckboxProps = React.ComponentProps<'input'> & {
  label: string
}

export const Checkbox = ({
  label,
  type = 'checkbox',
  className = '',
  ...inputProps
}: CheckboxProps) => {
  return (
    <label className="flex items-center">
      <input
        {...inputProps}
        type={type}
        className={'h-4 w-4 rounded border-border-default text-brand-hover focus-ring-form-control'}
      />
      <span className="ml-2 block text-sm text-heading">{label}</span>
    </label>
  )
}
